import SockJS from "sockjs-client";
import Stomp from "webstomp-client";

/**
 *Global container for SockJS, Stomp libraries and standard endpoints
 */
const SOCKET_ENDPOINT_BASE = process.env.VUE_APP_SOCKETS_ENDPOINT;
const PURCHASER_CHAT_INBOX = '/topic/purchaser.inbox'; // each specific purchaser inbox has a unique id param to be added after
const PURCHASER_CHAT_OUTBOX='/destination/purchaser/outbox';
const BROKER_CHAT_INBOX = '/topic/broker.inbox';
const BROKER_CHAT_OUTBOX = '/destination/broker/outbox';
const TEST_TOPIC = '/topic/test.check'
const TEST_END = '/destination/test/check'
const NOTIFICATION_TEST_SEND = '/destination/test/notification'
const NOTIFICATION_TEST_RECEIVE = '/topic/test.notification'
const NOTIFICATION = '/topic/notification.message'

export default  {
// needed to set up as plugin, used by Vue to make it global in main
  install: function(Vue) {
    //for globabl plugin installation if needed
   Object.defineProperty(Vue.prototype, '$ociSockets', { value: this });
  },
  //making sockJS and Stomp libraries accessible
  SockJS:SockJS,
  Stomp:Stomp,
  //Making Constants Accessible
  SOCKET_ENDPOINT_BASE :SOCKET_ENDPOINT_BASE,
  PURCHASER_CHAT_INBOX:PURCHASER_CHAT_INBOX,
  PURCHASER_CHAT_OUTBOX:PURCHASER_CHAT_OUTBOX,
  BROKER_CHAT_INBOX:BROKER_CHAT_INBOX,
  BROKER_CHAT_OUTBOX:BROKER_CHAT_OUTBOX,
  //Testing endpoints
  TEST_TOPIC:TEST_TOPIC,
  TEST_END:TEST_END,
  NOTIFICATION_TEST_SEND:NOTIFICATION_TEST_SEND,
  NOTIFICATION_TEST_RECEIVE:NOTIFICATION_TEST_RECEIVE,
  NOTIFICATION:NOTIFICATION



}
